import { render, staticRenderFns } from "./TableEmprestimosSemanas.vue?vue&type=template&id=d506d70c&"
import script from "./TableEmprestimosSemanas.vue?vue&type=script&lang=js&"
export * from "./TableEmprestimosSemanas.vue?vue&type=script&lang=js&"
import style0 from "./TableEmprestimosSemanas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports